// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/connections/public/v1/read_api.proto (package gdx.connections.public.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ListPaginationRequest, ListPaginationResponse } from "./pagination_pb.js";
import { ConnectionState, Dialog, DialogMessageView, User } from "./dialogs_pb.js";

/**
 * @generated from message gdx.connections.public.v1.GetConnectionsStatisticsRequest
 */
export class GetConnectionsStatisticsRequest extends Message<GetConnectionsStatisticsRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<GetConnectionsStatisticsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.GetConnectionsStatisticsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetConnectionsStatisticsRequest {
    return new GetConnectionsStatisticsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetConnectionsStatisticsRequest {
    return new GetConnectionsStatisticsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetConnectionsStatisticsRequest {
    return new GetConnectionsStatisticsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetConnectionsStatisticsRequest | PlainMessage<GetConnectionsStatisticsRequest> | undefined, b: GetConnectionsStatisticsRequest | PlainMessage<GetConnectionsStatisticsRequest> | undefined): boolean {
    return proto3.util.equals(GetConnectionsStatisticsRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.GetConnectionsStatisticsResponse
 */
export class GetConnectionsStatisticsResponse extends Message<GetConnectionsStatisticsResponse> {
  /**
   * @generated from field: int32 outgoing_likes = 1;
   */
  outgoingLikes = 0;

  /**
   * @generated from field: int32 incoming_likes = 6;
   */
  incomingLikes = 0;

  /**
   * @generated from field: int32 matches = 2;
   */
  matches = 0;

  /**
   * @generated from field: int32 dialogs = 3;
   */
  dialogs = 0;

  /**
   * @generated from field: int32 incoming_messages = 4;
   */
  incomingMessages = 0;

  /**
   * @generated from field: int32 outgoing_messages = 5;
   */
  outgoingMessages = 0;

  constructor(data?: PartialMessage<GetConnectionsStatisticsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.GetConnectionsStatisticsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "outgoing_likes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "incoming_likes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "matches", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "dialogs", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "incoming_messages", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "outgoing_messages", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetConnectionsStatisticsResponse {
    return new GetConnectionsStatisticsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetConnectionsStatisticsResponse {
    return new GetConnectionsStatisticsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetConnectionsStatisticsResponse {
    return new GetConnectionsStatisticsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetConnectionsStatisticsResponse | PlainMessage<GetConnectionsStatisticsResponse> | undefined, b: GetConnectionsStatisticsResponse | PlainMessage<GetConnectionsStatisticsResponse> | undefined): boolean {
    return proto3.util.equals(GetConnectionsStatisticsResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.ListDialogsRequest
 */
export class ListDialogsRequest extends Message<ListDialogsRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.connections.public.v1.ListPaginationRequest pagination = 2;
   */
  pagination?: ListPaginationRequest;

  /**
   * @generated from field: bool only_actual = 3;
   */
  onlyActual = false;

  constructor(data?: PartialMessage<ListDialogsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.ListDialogsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pagination", kind: "message", T: ListPaginationRequest },
    { no: 3, name: "only_actual", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDialogsRequest {
    return new ListDialogsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDialogsRequest {
    return new ListDialogsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDialogsRequest {
    return new ListDialogsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListDialogsRequest | PlainMessage<ListDialogsRequest> | undefined, b: ListDialogsRequest | PlainMessage<ListDialogsRequest> | undefined): boolean {
    return proto3.util.equals(ListDialogsRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.ListDialogsResponse
 */
export class ListDialogsResponse extends Message<ListDialogsResponse> {
  /**
   * @generated from field: gdx.connections.public.v1.ListPaginationResponse pagination = 1;
   */
  pagination?: ListPaginationResponse;

  /**
   * @generated from field: repeated gdx.connections.public.v1.Dialog items = 2;
   */
  items: Dialog[] = [];

  constructor(data?: PartialMessage<ListDialogsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.ListDialogsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: ListPaginationResponse },
    { no: 2, name: "items", kind: "message", T: Dialog, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDialogsResponse {
    return new ListDialogsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDialogsResponse {
    return new ListDialogsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDialogsResponse {
    return new ListDialogsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListDialogsResponse | PlainMessage<ListDialogsResponse> | undefined, b: ListDialogsResponse | PlainMessage<ListDialogsResponse> | undefined): boolean {
    return proto3.util.equals(ListDialogsResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.ListMatchesRequest
 */
export class ListMatchesRequest extends Message<ListMatchesRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.connections.public.v1.ListPaginationRequest pagination = 2;
   */
  pagination?: ListPaginationRequest;

  /**
   * @generated from field: bool only_actual = 3;
   */
  onlyActual = false;

  constructor(data?: PartialMessage<ListMatchesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.ListMatchesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pagination", kind: "message", T: ListPaginationRequest },
    { no: 3, name: "only_actual", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListMatchesRequest {
    return new ListMatchesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListMatchesRequest {
    return new ListMatchesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListMatchesRequest {
    return new ListMatchesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListMatchesRequest | PlainMessage<ListMatchesRequest> | undefined, b: ListMatchesRequest | PlainMessage<ListMatchesRequest> | undefined): boolean {
    return proto3.util.equals(ListMatchesRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.ListMatchesResponse
 */
export class ListMatchesResponse extends Message<ListMatchesResponse> {
  /**
   * @generated from field: gdx.connections.public.v1.ListPaginationResponse pagination = 1;
   */
  pagination?: ListPaginationResponse;

  /**
   * @generated from field: repeated gdx.connections.public.v1.Dialog items = 2;
   */
  items: Dialog[] = [];

  constructor(data?: PartialMessage<ListMatchesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.ListMatchesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: ListPaginationResponse },
    { no: 2, name: "items", kind: "message", T: Dialog, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListMatchesResponse {
    return new ListMatchesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListMatchesResponse {
    return new ListMatchesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListMatchesResponse {
    return new ListMatchesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListMatchesResponse | PlainMessage<ListMatchesResponse> | undefined, b: ListMatchesResponse | PlainMessage<ListMatchesResponse> | undefined): boolean {
    return proto3.util.equals(ListMatchesResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.GetDialogRequest
 */
export class GetDialogRequest extends Message<GetDialogRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string connection_id = 2;
   */
  connectionId = "";

  constructor(data?: PartialMessage<GetDialogRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.GetDialogRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDialogRequest {
    return new GetDialogRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDialogRequest {
    return new GetDialogRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDialogRequest {
    return new GetDialogRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetDialogRequest | PlainMessage<GetDialogRequest> | undefined, b: GetDialogRequest | PlainMessage<GetDialogRequest> | undefined): boolean {
    return proto3.util.equals(GetDialogRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.GetDialogResponse
 */
export class GetDialogResponse extends Message<GetDialogResponse> {
  /**
   * @generated from field: gdx.connections.public.v1.Dialog dialog = 1;
   */
  dialog?: Dialog;

  constructor(data?: PartialMessage<GetDialogResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.GetDialogResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "dialog", kind: "message", T: Dialog },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetDialogResponse {
    return new GetDialogResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetDialogResponse {
    return new GetDialogResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetDialogResponse {
    return new GetDialogResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetDialogResponse | PlainMessage<GetDialogResponse> | undefined, b: GetDialogResponse | PlainMessage<GetDialogResponse> | undefined): boolean {
    return proto3.util.equals(GetDialogResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.ListDialogMessagesRequest
 */
export class ListDialogMessagesRequest extends Message<ListDialogMessagesRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.connections.public.v1.ListPaginationRequest pagination = 2;
   */
  pagination?: ListPaginationRequest;

  /**
   * @generated from field: string connection_id = 3;
   */
  connectionId = "";

  constructor(data?: PartialMessage<ListDialogMessagesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.ListDialogMessagesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pagination", kind: "message", T: ListPaginationRequest },
    { no: 3, name: "connection_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDialogMessagesRequest {
    return new ListDialogMessagesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDialogMessagesRequest {
    return new ListDialogMessagesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDialogMessagesRequest {
    return new ListDialogMessagesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListDialogMessagesRequest | PlainMessage<ListDialogMessagesRequest> | undefined, b: ListDialogMessagesRequest | PlainMessage<ListDialogMessagesRequest> | undefined): boolean {
    return proto3.util.equals(ListDialogMessagesRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.ListDialogMessagesResponse
 */
export class ListDialogMessagesResponse extends Message<ListDialogMessagesResponse> {
  /**
   * @generated from field: gdx.connections.public.v1.ListPaginationResponse pagination = 1;
   */
  pagination?: ListPaginationResponse;

  /**
   * @generated from field: repeated gdx.connections.public.v1.DialogMessageView items = 2;
   */
  items: DialogMessageView[] = [];

  constructor(data?: PartialMessage<ListDialogMessagesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.ListDialogMessagesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: ListPaginationResponse },
    { no: 2, name: "items", kind: "message", T: DialogMessageView, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListDialogMessagesResponse {
    return new ListDialogMessagesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListDialogMessagesResponse {
    return new ListDialogMessagesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListDialogMessagesResponse {
    return new ListDialogMessagesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListDialogMessagesResponse | PlainMessage<ListDialogMessagesResponse> | undefined, b: ListDialogMessagesResponse | PlainMessage<ListDialogMessagesResponse> | undefined): boolean {
    return proto3.util.equals(ListDialogMessagesResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.ListBlockedUsersRequest
 */
export class ListBlockedUsersRequest extends Message<ListBlockedUsersRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: gdx.connections.public.v1.ListPaginationRequest pagination = 2;
   */
  pagination?: ListPaginationRequest;

  constructor(data?: PartialMessage<ListBlockedUsersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.ListBlockedUsersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pagination", kind: "message", T: ListPaginationRequest },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListBlockedUsersRequest {
    return new ListBlockedUsersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListBlockedUsersRequest {
    return new ListBlockedUsersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListBlockedUsersRequest {
    return new ListBlockedUsersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListBlockedUsersRequest | PlainMessage<ListBlockedUsersRequest> | undefined, b: ListBlockedUsersRequest | PlainMessage<ListBlockedUsersRequest> | undefined): boolean {
    return proto3.util.equals(ListBlockedUsersRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.ListBlockedUsersResponse
 */
export class ListBlockedUsersResponse extends Message<ListBlockedUsersResponse> {
  /**
   * @generated from field: gdx.connections.public.v1.ListPaginationResponse pagination = 1;
   */
  pagination?: ListPaginationResponse;

  /**
   * @generated from field: repeated gdx.connections.public.v1.User items = 2;
   */
  items: User[] = [];

  constructor(data?: PartialMessage<ListBlockedUsersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.ListBlockedUsersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pagination", kind: "message", T: ListPaginationResponse },
    { no: 2, name: "items", kind: "message", T: User, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListBlockedUsersResponse {
    return new ListBlockedUsersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListBlockedUsersResponse {
    return new ListBlockedUsersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListBlockedUsersResponse {
    return new ListBlockedUsersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListBlockedUsersResponse | PlainMessage<ListBlockedUsersResponse> | undefined, b: ListBlockedUsersResponse | PlainMessage<ListBlockedUsersResponse> | undefined): boolean {
    return proto3.util.equals(ListBlockedUsersResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.GetUniqueIdRequest
 */
export class GetUniqueIdRequest extends Message<GetUniqueIdRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  constructor(data?: PartialMessage<GetUniqueIdRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.GetUniqueIdRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUniqueIdRequest {
    return new GetUniqueIdRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUniqueIdRequest {
    return new GetUniqueIdRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUniqueIdRequest {
    return new GetUniqueIdRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetUniqueIdRequest | PlainMessage<GetUniqueIdRequest> | undefined, b: GetUniqueIdRequest | PlainMessage<GetUniqueIdRequest> | undefined): boolean {
    return proto3.util.equals(GetUniqueIdRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.GetUniqueIdResponse
 */
export class GetUniqueIdResponse extends Message<GetUniqueIdResponse> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetUniqueIdResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.GetUniqueIdResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetUniqueIdResponse {
    return new GetUniqueIdResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetUniqueIdResponse {
    return new GetUniqueIdResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetUniqueIdResponse {
    return new GetUniqueIdResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetUniqueIdResponse | PlainMessage<GetUniqueIdResponse> | undefined, b: GetUniqueIdResponse | PlainMessage<GetUniqueIdResponse> | undefined): boolean {
    return proto3.util.equals(GetUniqueIdResponse, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.BatchGetConnectionStateRequest
 */
export class BatchGetConnectionStateRequest extends Message<BatchGetConnectionStateRequest> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * subject user ids
   *
   * @generated from field: repeated string ids = 2;
   */
  ids: string[] = [];

  constructor(data?: PartialMessage<BatchGetConnectionStateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.BatchGetConnectionStateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetConnectionStateRequest {
    return new BatchGetConnectionStateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetConnectionStateRequest {
    return new BatchGetConnectionStateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetConnectionStateRequest {
    return new BatchGetConnectionStateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetConnectionStateRequest | PlainMessage<BatchGetConnectionStateRequest> | undefined, b: BatchGetConnectionStateRequest | PlainMessage<BatchGetConnectionStateRequest> | undefined): boolean {
    return proto3.util.equals(BatchGetConnectionStateRequest, a, b);
  }
}

/**
 * @generated from message gdx.connections.public.v1.BatchGetConnectionStateResponse
 */
export class BatchGetConnectionStateResponse extends Message<BatchGetConnectionStateResponse> {
  /**
   * @generated from field: map<string, gdx.connections.public.v1.ConnectionState> items = 1;
   */
  items: { [key: string]: ConnectionState } = {};

  constructor(data?: PartialMessage<BatchGetConnectionStateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.connections.public.v1.BatchGetConnectionStateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: ConnectionState} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BatchGetConnectionStateResponse {
    return new BatchGetConnectionStateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BatchGetConnectionStateResponse {
    return new BatchGetConnectionStateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BatchGetConnectionStateResponse {
    return new BatchGetConnectionStateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: BatchGetConnectionStateResponse | PlainMessage<BatchGetConnectionStateResponse> | undefined, b: BatchGetConnectionStateResponse | PlainMessage<BatchGetConnectionStateResponse> | undefined): boolean {
    return proto3.util.equals(BatchGetConnectionStateResponse, a, b);
  }
}

